function initBannerSwiper(container) {
  // Pega o tempo de transição do atributo data
  const tempoDelayString = container.dataset.tempodelay;
  const tempoDelay = parseFloat(tempoDelayString) * 1000;

  // Seletores dinâmicos para paginação e navegação
  const paginationEl = `#${container.id} .swiper-pagination`;
  const nextEl = `#${container.id} .swiper-button-next`;
  const prevEl = `#${container.id} .swiper-button-prev`;

  // Configuração do Swiper
  const swiperConfig = {
    effect: "fade",
    autoplay: {
      delay: tempoDelay || 5000, // Usa 5s como padrão se não for definido
      disableOnInteraction: false, // Continua após interação
      pauseOnMouseEnter: true // Pausa quando o mouse está sobre o slide
    },
    pagination: {
      el: paginationEl,
      clickable: true,
      dynamicBullets: false // Desativa bullets dinâmicos para manter controle total do estilo
    },
    
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    loop: true,
    lazyLoading: true,
    fadeEffect: {
      crossFade: true // Melhora o efeito de fade entre slides
    },
    speed: 600, // Velocidade da transição em ms
    
    // Eventos
    on: {
      init: function() {
        // Adiciona classe para indicar que o swiper foi inicializado
        container.classList.add('swiper-initialized');
      },
      
      slideChange: function() {
        // Dispara evento customizado quando o slide muda
        // Útil para analytics ou outras integrações
        const event = new CustomEvent('bannerChange', {
          detail: { slideIndex: this.activeIndex }
        });
        container.dispatchEvent(event);
      }
    }
  };

  const swiper = new Swiper(container, swiperConfig);
  
  // Adiciona suporte para teclas de navegação
  container.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      swiper.slidePrev();
    } else if (e.key === 'ArrowRight') {
      swiper.slideNext();
    }
  });
  
  // Melhora acessibilidade
  container.setAttribute('role', 'region');
  container.setAttribute('aria-label', 'Banner carousel');
}

// Encontra todos os banners na página e inicia cada um
document.addEventListener('DOMContentLoaded', () => {
  // Aguarda um momento para garantir que o Swiper está carregado
  setTimeout(() => {
    document.querySelectorAll('.banner-wrapper.swiper').forEach(banner => {
      initBannerSwiper(banner);
    });
  }, 100);
});

// Reinicia o swiper caso a página seja redimensionada (responsividade)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.querySelectorAll('.banner-wrapper.swiper').forEach(banner => {
      if (banner.swiper) {
        banner.swiper.update();
      }
    });
  }, 250);
});